import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { reduxForm, Field, formValueSelector, getFormValues } from 'redux-form';

import Content from '../common/template/content';
import ContentCard from '../common/template/contentCard';
import ContentCardHeader from '../common/template/contentCardHeader';
import ContentCardBody from '../common/template/contentCardBody';
import ContentCardFooter from '../common/template/contentCardFooter';
import Row from '../common/layout/row';
import Grid from '../common/layout/grid';
import Button from '../common/button/button';
import Form from '../common/form/form';
import LabelAndInput from '../common/form/labelAndInput';
import LabelAndTextarea from '../common/form/labelAndTextarea';
import LabelAndInputNumber from '../common/form/labelAndInputNumber';
import LabelAndInputMask from '../common/form/labelAndInputMask';
import LabelAndInputDateTime from '../common/form/labelAndInputDateTime';
import Select from '../common/form/select';
import SelectAlteracao from '../common/form/selectAlteracao';
import LabelAndCheckbox from '../common/form/labelAndCheckbox';

import {
	setModoTela, initForm
} from './incubacaoActions';
import consts from '../consts';
import ClipboardImageHandler from '../common/form/ClipboardImageHandler';
import LabelAndInputDate from '../common/form/labelAndInputDate';

class IncubacaooForm extends Component {

	state = {

	}

    componentWillMount() {

    }

    render() {

		let readOnly = this.props.excluir || this.props.visualizacao ? 'readOnly' : '';

		
		return (
			<Row alignCenter>
				<Grid cols='12 10 8 5'>
					<ContentCard
						style={{
							marginTop: 20,
							backgroundColor: '#0F2748',
							color: '#ffffff',
							borderRadius: 20,
							boxShadow: '0px 0px 10px rgba(255, 255, 255, 0.9)',
							opacity: '80%'
						}}>
						<ContentCardHeader
							style={{
								marginTop: 16,
								marginBottom: 16
							}}>
							<label>{this.props.formularioValues.id ? 'Trilha de incubação' : 'Crie uma nova trilha de incubação'}</label>
						</ContentCardHeader>
						<Form event={this.props.handleSubmit}>
							<ContentCardBody>
								<Row>
								
									<Select
										name='id_empreendedores'
										options={this.props.listaUsuario}
										label='Empreendedores *'
										cols='12 12 12 12'
										placeholder='Selecione'
										readOnly={readOnly}
										multiple
										value={this.props.formularioValues.id_empreendedores}
										onChange={values => {
											this.props.initForm({
												...this.props.formularioValues,
												id_empreendedores: values.map(item => item.value)
											});
										}} />

									<Field
										name='nome_empresa'
										component={LabelAndInput}
										label='Nome da Empresa: *' placeholder=''
										cols='12 12 12 12'
										readOnly={readOnly} />

									<LabelAndInputDate
										maxWidth={180}
										name='data_incubacao'
										label='Data da Incubação *' placeholder='Informe'
										cols='12 6 4 3'
										readOnly={readOnly}
										value={this.props.formularioValues.data_incubacao}
										onChange={value => {
											this.props.initForm({
												...this.props.formularioValues,
												data_incubacao: value
											});
										}} />
								</Row>
								<Row>
									<LabelAndInputDate
										maxWidth={180}
										name='data_ano1'
										label='Data 1º Ano *' placeholder='Informe'
										cols='12 6 4 3'
										readOnly={readOnly}
										value={this.props.formularioValues.data_ano1}
										onChange={value => {
											this.props.initForm({
												...this.props.formularioValues,
												data_ano1: value
											});
										}} />
									
									{!!this.props.formularioValues.data_ano1 &&
									<Field
										name='parecer_ano1'
										component={LabelAndTextarea}
										label='Parecer do 1º ano: *' placeholder=''
										cols='12 12 12 12'
										readOnly={readOnly}
										rows={5} />}
								</Row>	
								<Row>
									{this.props.formularioValues.data_ano1 &&
									<LabelAndInputDate
										maxWidth={180}
										name='data_ano2'
										label='Data 2º Ano *' placeholder='Informe'
										cols='12 6 4 3'
										readOnly={readOnly}
										value={this.props.formularioValues.data_ano2}
										onChange={value => {
											this.props.initForm({
												...this.props.formularioValues,
												data_ano2: value
											});
										}} />}
									{this.props.formularioValues.data_ano2 &&
									<Field
										name='parecer_ano2'
										component={LabelAndTextarea}
										label='Parecer do 2º ano: *' placeholder=''
										cols='12 12 12 12'
										readOnly={readOnly}
										rows={5} />}
								</Row>
								<Row>
									{this.props.formularioValues.data_ano2 &&
									<LabelAndInputDate
										maxWidth={180}
										name='data_ano3'
										label='Data 3º Ano *' placeholder='Informe'
										cols='12 6 4 3'
										readOnly={readOnly}
										value={this.props.formularioValues.data_ano3}
										onChange={value => {
											this.props.initForm({
												...this.props.formularioValues,
												data_ano3: value
											});
										}} />}
									{this.props.formularioValues.data_ano3 &&
									<Field
										name='parecer_ano3'
										component={LabelAndTextarea}
										label='Parecer do 3º ano: *' placeholder=''
										cols='12 12 12 12'
										readOnly={readOnly}
										rows={5} />}
								</Row>
								<Row>
									{this.props.formularioValues.data_ano3 &&
									<LabelAndInputDate
										maxWidth={180}
										name='data_graduacao'
										label='Data da Graduação *' placeholder='Informe'
										cols='12 6 4 3'
										readOnly={readOnly}
										value={this.props.formularioValues.data_graduacao}
										onChange={value => {
											this.props.initForm({
												...this.props.formularioValues,
												data_graduacao: value
											});
										}} />}
									{this.props.formularioValues.data_ano3 &&
									<Field
										name='parecer_final'
										component={LabelAndTextarea}
										label='Parecer Final: *' placeholder=''
										cols='12 12 12 12'
										readOnly={readOnly}
										rows={5} />}
								</Row>

								<Row alignCenter>
									{!this.props.visualizacao &&
									<Grid cols='8 8 8 8'>
										{this.props.excluir ? (
											<Button
												text='Excluir'
												submit type={'danger'}
												icon={'fa fa-trash'} />
										) : (
										<Button
											text={this.props.formularioValues.id ? 'Salvar' : 'Iniciar'}
											submit
											type={'success'}
											icon={'fa fa-check'} />
										)}
									</Grid>}
									<Grid cols='4 4 4 4'>
										<Button
											text='Voltar'
											type={'success'}
											icon={'fa fa-chevron-left'}
											event={() => window.confirm('Deseja realmente sair dessa tela?') ? this.props.setModoTela('trilha') : null} />
									</Grid>
								</Row>
							</ContentCardBody>
						</Form>
					</ContentCard>
				</Grid>
			</Row>
		);
    }


}

IncubacaooForm = reduxForm({form: 'incubacaoForm', destroyOnUnmount: false})(IncubacaooForm);
const mapStateToProps = state => ({
	sessao: state.auth.usuario,
	formularioValues: getFormValues('incubacaoForm')(state),
	registro: state.incubacao.registro,
	lista: state.incubacao.lista,
	listaUsuario: state.incubacao.listaUsuario
});
const mapDispatchToProps = dispatch => bindActionCreators({
	setModoTela, initForm
}, dispatch);
export default connect(mapStateToProps, mapDispatchToProps)(IncubacaooForm);
